import { createUseStyles } from 'react-jss'
import { darkGrey, lightGrey, mediumGrey } from '../const/colors'
import { defaultBorderRadius } from '../const/common'
import { tabletDown } from '../const/breakpoints'

const useStyles = createUseStyles({
  page: {
    marginTop: 30,
    paddingBottom: 60
  },
  welcomeMessage: {
    marginTop: 44,
    marginBottom: 16,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '20px'
  },
  welcomeButtonsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 16,
    rowGap: 8
  },
  graphsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridGap: 40,
    marginTop: 28
  },
  dateRangeLabel: {
    color: mediumGrey,
    paddingRight: 20
  },
  section: {
    marginTop: 44
  },
  pasteAdButton: {
    background: 'white',
    border: {
      width: 2,
      style: 'solid',
      color: lightGrey
    },
    borderRadius: defaultBorderRadius,
    width: 40,
    minWidth: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      fill: lightGrey,
      width: 20,
      height: 20
    }
  },

  sectionTitle: {
    color: darkGrey,
    fontSize: 18,
    fontWeight: 500,
    margin: 0
  },
  itemsList: {
    paddingLeft: 0,
    marginTop: 12,
    listStyle: 'none'
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: -8,
    '& > *': {
      marginBottom: 8
    },
    '& > *:not(:last-child)': {
      marginRight: 8
    }
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 2,
    '& > div': {
      marginTop: 3
    }
  },
  [`@media screen and (${tabletDown})`]: {
    pasteAdButton: {
      width: 48,
      height: 48
    }
  }
})

export default useStyles
